import actions from './actionsList';
export default (state = {}, action) => {
  switch (action.type) {
  case actions.SET_TOKEN:
    return Object.assign({}, state, {token: action.token});
  default:
    return state;
  }
};
